// extracted by mini-css-extract-plugin
export default {"container":"ResetPassword_container__Ghn80","succesfulText":"ResetPassword_succesfulText__zFHo6"};